/* eslint-disable import/prefer-default-export */
export const sortFilterId = "sort-filter-dropdown";
